<template>
	<ParentComponent side="left" divId="div1" selectContentClass="selectContent1" />
</template>

<script setup>
	import ParentComponent from "@/components/compoents_base/ParentComponent.vue";
</script>
